import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import SelectBox from '../component/Select.js';
import Input from '../component/Input.js';
import Validation from './Validation.js';
import Modal from 'react-modal';
import sparkles2 from '../asset/img/sparkles2.png';
import loader from '../asset/img/loader.gif';

export default class ManageVirtues extends Component {
	constructor(props){
		super(props);
		this.state = {rows:1,newVirtues:[],editVirtues:[],failedVirtues:[],modalIsOpen:false,loading:false,modalPrompt:''};
		this.addRows = this.addRows.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	addRows(){ //add rows of input field for creating new lov values
		let rows = this.state.rows+1;
		this.setState({rows:rows});
	}

	handleEdit(identity,value){ //method for handling status update of lov values
		let virtueState = this.state.editVirtues;
		virtueState[identity].lov_status = value;
		this.setState({editVirtues:virtueState});
	}

	handleInput(identity,value){ //method for handling user input for new value creation
		let virtueState = this.state.newVirtues;
		virtueState[identity] = value;
		this.setState({newVirtues:virtueState});
	}

	closeModal(){ //close the modal
		this.setState({modalIsOpen:false,failedVirtues:[]});
	}

	componentDidUpdate(prevProps){
		if(prevProps.save !== this.props.save && this.props.save){
			this.setState({loading:true},function(){
				this.setState({modalIsOpen:true});
			});
			if(this.props.create){ //if user has chosen to save new values that they have created
				let newVirtues = this.state.newVirtues;
				let failures = [];
				if(newVirtues.length > 0){ //make sure that they are not trying to save empty input field(s)
					axios.all(newVirtues.map(virtues=>{
						if(Validation("name",virtues)){ //validate user input
						return (axios({
											method:'post',
											url:path,headers:{'Content-Type':'application/json'},
											data:{endpoint:'create',table:'virtues',misc:'create',desc:virtues}
										}).catch((error)=>{
											failures.push(virtues);
										})
									  )
						}else{
							failures.push(virtues);
						}
					})).then(()=>{
						if(failures.length < 1){ //success message
							this.setState({modalPrompt:'Value(s) successfully created!'});
						}
						this.setState({failedVirtues:failures,newVirtues:[],rows:1},function(){
							this.props.reset("virtues");
							this.setState({loading:false});
						});
					});
				}else{ //display message if user attempted to save with no new values
					this.setState({newVirtues:[],modalPrompt:'Please enter at least one value.'},function(){
						this.setState({loading:false});
						this.props.revertSave();
					});
				}
			}else if(this.props.edit){ //if user is saving edited lov values
				let editVirtues = this.state.editVirtues;
				let failures = [];
				axios.all(editVirtues.map(virtues=>{
					return (axios({
										method:'post',
										url:path,headers:{'Content-Type':'application/json'},
										data:{endpoint:'create',table:'virtues',misc:'status',firstID:virtues.ID,status:virtues.lov_status}
									}).catch((error)=>{
										failures.push(virtues);
									})
								  )
				})).then(()=>{
					if(failures.length < 1){ //success message
						this.setState({modalPrompt:'Value(s) successfully updated!'});
					}
					this.setState({failedVirtues:failures,editVirtues:[]},function(){
						this.props.reset("virtues");
						this.setState({loading:false});
					});
				});
			}
		}else if(prevProps.edit !== this.props.edit && this.props.edit){
			this.setState({editVirtues:this.props.virtues});
		}
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    minWidth:'300px',
		    maxWidth:'600px',
		    minHeight:'200px',
		    maxHeight:'600px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    backgroundImage:'url('+sparkles2+')',
		    backgroundRepeat:'no-repeat',
		    backgroundSize: '300px 160px',
		    backgroundPosition:'right',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			},  
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		const selectStyles = "h2 pa1 w-90-ns w-100 br2 bw1 truncate shadow-2";
		let label;
		let virtues;
		let input = [];
		let add;
		const labelStyle = {marginBlockStart:'1em', marginBlockEnd:'1em'};
		const inputStyles = "pa2 shadow-2 br2 bw1 w-100-ns w-100 mw6";
		if(!(this.props.edit)){ //display current lov values
			virtues = this.props.virtues.map((virtues)=>{
				return <li key={virtues.ID} className="fl w-100"><p className="fl w-75 navy b">{virtues.virtue}</p><p className="fl w-25"><span className="b navy">Status:</span> {virtues.lov_status}</p></li>;
			});
			if(this.props.create){ //display input field for new value creation
				label = <label className="tl fl navy b">Value: </label>;
				for(let i=0;i<this.state.rows;i++){
					input.push(<div key={i} className="pb2">{label}<Input type="text" identity={i} onInput={this.handleInput} inputStyle={inputStyles}/></div>);
				}
				add = <a href="#" onClick={this.addRows}>+Add</a>;
			}
		}else if(this.props.edit){ //display dropdown menu with active and inactive options for each value
			virtues = this.state.editVirtues.map((virtues,i)=>{
				return (<li key={virtues.ID} className="fl w-100"><div className="fl w-60 b navy mt1"><p>{virtues.virtue}</p></div>
									<div className="fl w-40" style={labelStyle}><div className="fl w-35 pr2"><label className="fl w-35 b navy mt1">Status: </label></div><div className="fl w-65"><SelectBox identity={i} onSelect={this.handleEdit}  options={["active","inactive"]} val={virtues.lov_status} styles={selectStyles}/></div></div></li>);
			});
		}
		let modalContent;
		if(this.state.loading){ //display loading gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else if(this.state.failedVirtues.length > 0){ //display values that failed due to connection or validation
			modalContent = <div>
											<div className="fl w-100 tr">
							        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
							        </div>
											<div className="tc"><p className="tc b f4 navy">There was a problem creating the following virtues: </p>
    										<div style={{overflowY:'auto'}}><UnOrderedList failed={this.state.failedVirtues}/></div>
    								</div>
    								</div>;
		}else{ //display message
			modalContent = <div>
												<div className="fl w-100 tr">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
												<p className="tc b navy f4">{this.state.modalPrompt}</p>;
											</div>
		}
		return(
			<div style={{maxWidth:'550px',margin:'auto'}}>
				<ul className="list">
					{virtues}
				</ul>
				<ul  className="list">
				{input}
				<li>
					<div className="tr">
						{add}
					</div>
				</li>
				</ul>
				<div>
					<Modal
		          isOpen={this.state.modalIsOpen}
		          style={customStyles}
		          contentLabel="Values Modal"
		          shouldCloseOnOverlayClick={false}
		          shouldCloseOnEsc={false}
		        >
		        {modalContent}
		        </Modal>
				</div>
			</div>
		);
	}
}
const UnOrderedList = props =>{ //unordered list for displaying values that were not created due to failure
		let li = props.failed.map((failed,i)=>{
			return <li key={i} className="fl w-100"><p className="fl w-100 b f5 navy tc pa0 bb b--light-silver mt0">{failed}</p></li>;
		});
		return <ul className="fl w-100">{li}</ul>;
}


// WEBPACK FOOTER //
// ./src/container/ManageVirtues.js